<template lang="pug">
.notification-terminate-modal
  b-modal(v-model="_value" size="lg" hide-header no-close-on-backdrop no-close-on-esc @ok="ok")
    .default-modal-body
      .messages.d-flex.flex-column
        span 現在、解約依頼中です。
        span 解約依頼の取り消しをされない場合は、今月末でサービス終了となります。
        span もしサービスの継続をご希望の場合は、「設定」→「解約のお手続き」より解約依頼の取り消しをお願いします。

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 解約依頼中通知モーダル
 */
@Component
export default class NotificationTerminateModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>

<style lang="scss" scoped>
.messages {
  font-size: 16px;
  .strong {
    font-weight: bold;
  }
}
</style>
